function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".wqdq_32{fill:#3f7aec;}.bdwdwd_23{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.162)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "wqdq_32",
  width: 40,
  height: 40,
  rx: 5,
  transform: "translate(-0.162)"
}), /*#__PURE__*/React.createElement("path", {
  className: "bdwdwd_23",
  d: "M23.306,14.492H14.492v8.814a1.893,1.893,0,0,1-3.786,0V14.492H1.893a1.893,1.893,0,0,1,0-3.786h8.814V1.893a1.893,1.893,0,0,1,3.786,0v8.814h8.814a1.893,1.893,0,1,1,0,3.786Z",
  transform: "translate(7.32 7.32)"
}));

function SvgAddCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleIcon);
export default __webpack_public_path__ + "static/media/add-circle-icon.71e0cce0.svg";
export { ForwardRef as ReactComponent };